'use client';

import Footer from '../../../components/Footer/Footer';
import Header from '../../../components/Header/Header';
import MainNav from '../../../components/MainNav/MainNav';
import MobileNav from '../../../components/MobileNav/MobileNav';
import { useFriendlyViewPort } from '../../../hooks/useFriendlyViewPort';
import { useViewportSizeTracking } from '../../../hooks/useViewportSizeTracking';
import tjenesterVal from '../../../content/pages/tjenester.val';
import { useVal } from '../../../val/val.client';
import ContactSales from '../../../components/ContactSales/ContactSales';
import PageElement from '../../../components/PageElements/PageElement';
import PageIngress from '../../../components/PageIngress/PageIngress';
import LargeLayout from '../../../containers/LargeLayout';
import PageHeader from '../../../components/PageHeader/PageHeader';
import BlankLink from '../../../components/BlankLink/BlankLink';

const Services = () => {
  const { header, pageImage, subheader, ingress, pageElements, contactLink } =
    useVal(tjenesterVal);

  useFriendlyViewPort();
  useViewportSizeTracking();

  return (
    <>
      <div id="tjenester">
        <Header>
          <MainNav />
          <MobileNav />
        </Header>
        <LargeLayout>
          <PageHeader header={header} subheader={subheader} image={pageImage} />

          <PageIngress
            text={ingress}
            rightContent={
              <div className="tablet:text-right">
                <BlankLink href={contactLink.href}>
                  {contactLink.text}
                </BlankLink>
              </div>
            }
          />

          {pageElements.map((element, i) => {
            return <PageElement key={i} element={element} />;
          })}

          <ContactSales />
        </LargeLayout>
        <Footer />
      </div>
    </>
  );
};

export default Services;
